import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const getTaskComments = (queryRequest:string) => get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/comments?${queryRequest}`);

export const getSpecificTaskComment = (id: string) =>
	get(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/comments/${id}`);

export const addTaskComments = (payload: object) =>
	post(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/comments`, payload);

export const updateTaskComments = (id: string, payload: object) =>
	patch(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/comments/${id}`, payload);

export const deleteTaskComments = (id: String) =>
	Delete(`${process.env.REACT_APP_API_URL?process.env.REACT_APP_API_URL:config.API_URL}/audit/comments/${id}`);
